import { render } from "./HeadingForms.vue?vue&type=template&id=f0b36dfc&scoped=true"
import script from "./HeadingForms.vue?vue&type=script&lang=js"
export * from "./HeadingForms.vue?vue&type=script&lang=js"

import "./HeadingForms.vue?vue&type=style&index=0&id=f0b36dfc&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b36dfc"]])

export default __exports__